(function () {
    function expandResourceAccordions() {
        document.querySelectorAll('[data-rutina-accordion] [class$="__item"]').forEach((item) => {
            item.classList.add('is-open');

            const head = item.querySelector('[class$="__head"]');

            if (head) {
                head.setAttribute('aria-expanded', 'true');
            }
        });

        document.querySelectorAll('[data-rutina-meals] [data-meal-panel]').forEach((panel) => {
            panel.hidden = false;
        });
    }

    function collectStylesheets() {
        return [...document.querySelectorAll('link[rel="stylesheet"]')]
            .map((link) => {
                if (!link.href) {
                    return '';
                }

                return `<link rel="stylesheet" href="${link.href}">`;
            })
            .join('');
    }

    function printResourceGuide() {
        expandResourceAccordions();

        const sections = [...document.querySelectorAll('.resource-savage')];

        if (sections.length === 0) {
            window.print();
            return;
        }

        const iframe = document.createElement('iframe');
        iframe.setAttribute('aria-hidden', 'true');
        iframe.style.cssText = 'position:fixed;width:0;height:0;border:0;visibility:hidden;';
        document.body.appendChild(iframe);

        const frameWindow = iframe.contentWindow;
        const doc = frameWindow.document;
        const content = sections.map((section) => section.outerHTML).join('');
        const stylesheets = collectStylesheets();

        doc.open();
        doc.write(`<!DOCTYPE html>
<html lang="${document.documentElement.lang || 'lt'}">
<head>
<meta charset="utf-8">
<title>${document.title.replace(/</g, '&lt;')}</title>
${stylesheets}
<style>
@page { size: A4; margin: 0; }
html, body {
    margin: 0 !important;
    padding: 12mm 10mm !important;
    background: #090908 !important;
    color: #f5f2ec !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
}
</style>
</head>
<body>${content}</body>
</html>`);
        doc.close();

        let printed = false;

        const runPrint = () => {
            if (printed) {
                return;
            }

            printed = true;
            frameWindow.focus();
            frameWindow.print();

            window.setTimeout(() => {
                iframe.remove();
            }, 1500);
        };

        iframe.addEventListener('load', () => {
            window.setTimeout(runPrint, 300);
        });

        window.setTimeout(runPrint, 1200);
    }

    function bindPrintButtons() {
        document.querySelectorAll('[data-resource-print]').forEach((button) => {
            if (button.dataset.resourcePrintReady === '1') {
                return;
            }

            button.dataset.resourcePrintReady = '1';
            button.addEventListener('click', (event) => {
                event.preventDefault();
                printResourceGuide();
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bindPrintButtons, { once: true });
    } else {
        bindPrintButtons();
    }
})();
